import { render, staticRenderFns } from "./MealPlanParameters.vue?vue&type=template&id=48606f62"
import script from "./MealPlanParameters.vue?vue&type=script&lang=js"
export * from "./MealPlanParameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports